module.exports = __webpack_public_path__ + "img/logo_kiddy_motion-01.8bf6062b.png";